import {capSQLiteSet} from "@capacitor-community/sqlite/src/definitions";

export class SQLRun {
  sql: string
  args: any[]

  constructor(sql: string, args: any[]) {
    this.sql = sql
    this.args = args
  }

  tocapSQLiteSet(): capSQLiteSet{
    return {statement: this.sql, values: this.args}
  }
}
